import axios from "axios";

export async function requestGetQuranAnnotationList({
	page = 1,
	limit = 10,
	order = "_id:desc",
	keyword = "",
	filter = "",
}) {
	return await axios.get(
		`${
			import.meta.env.VITE_API_URL
		}/admin/@quran/annotations?page=${page}&limit=${limit}&keyword=${encodeURIComponent(
			keyword
		)}&filter=${filter}&order=${order}`
	);
}

export async function requestShowQuranAnnotation(chapter, verse) {
	return axios.get(`${import.meta.env.VITE_API_URL}/admin/@quran/annotations/${chapter}/${verse}`);
}

export async function requestSetQuranAnnotation(payload) {
	return await axios.post(`${import.meta.env.VITE_API_URL}/admin/@quran/annotations/set`, payload);
}

export async function requestVerifyQuranAnnotation(chapter, verse) {
	return await axios.put(
		`${import.meta.env.VITE_API_URL}/admin/@quran/annotations/${chapter}/${verse}/verify`
	);
}

export async function requestUnverifyQuranAnnotation(chapter, verse) {
	return await axios.put(
		`${import.meta.env.VITE_API_URL}/admin/@quran/annotations/${chapter}/${verse}/unverify`
	);
}
